const locale = {
  on: '开启',
  off: '关闭'
};
export default locale;